export default function getCurrencySign(currencyCode) {
  if (currencyCode && typeof currencyCode === 'string') {
    switch (currencyCode.toLowerCase()) {
      case 'eur':
        return '€';
      case 'usd':
        return '$';
      case 'gbp':
        return '£';
      case 'cad':
        return 'C$';
      case 'sgd':
        return 'S$';
      case 'aud':
        return 'A$';
      case 'ils':
        return '₪';
      default:
        return '';
    }
  }
  return '';
}